import { HouseType } from 'app/pages/order/model/house-type';
import { OrderStaticData } from 'app/static-data/order-static-data';

export class OrderService {
    public static getAmountOfWifiUnitsToReceive = (freeUnitAdded: boolean, amountOfUnitsToPurchase: number): number =>
        freeUnitAdded ? amountOfUnitsToPurchase + 1 : amountOfUnitsToPurchase;

    public static getAmountOfWifiUnitsToBePurchased(
        isPurchasingSingleUnit: boolean,
        isExtraUnitNeeded: boolean,
        selectedHouseType: HouseType,
    ): number {
        if (isPurchasingSingleUnit) {
            return OrderStaticData.SINGLE_UNIT_AMOUNT;
        }

        const numberOfWifiUnits = OrderService.getNumberOfWifiUnitsByHouseType(selectedHouseType);

        return isExtraUnitNeeded ? numberOfWifiUnits + OrderStaticData.EXTRA_UNIT_AMOUNT : numberOfWifiUnits;
    }

    public static getNumberOfWifiUnitsByHouseType(houseType: HouseType): number {
        switch (houseType) {
            case HouseType.MEDIUM_HOUSE:
                return OrderStaticData.MEDIUM_HOUSE_UNIT_AMOUNT;
            case HouseType.LARGE_HOUSE:
                return OrderStaticData.LARGE_HOUSE_UNIT_AMOUNT;
            default:
                throw new Error('Not supported house type');
        }
    }
}
